module.exports = __webpack_public_path__ + "assets/img/wip_icon.svg";